import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange } from '@angular/core';
import { SongDetailComponent } from '../';
import { AuthService } from '../../api/';
import { Helper } from '../../helper';
import { MdDialog, MdDialogRef } from '@angular/material';
import { AlbumsService } from '../../api';
import { PlayerService } from '../../player';

@Component({
  selector: 'app-gridview-songs',
  templateUrl: './gridview-songs.component.html',
  styleUrls: ['./gridview-songs.component.css']
})
export class GridviewSongsComponent implements OnInit,OnChanges {
  @Input() song: any;
  @Input() artist: any;
  @Input() type: string = '';
  @Input() hideOptions: boolean = false;
  @Input() showDeleteSongFromPlaylist: boolean = false;
  @Output() refreshListing: EventEmitter<any> = new EventEmitter();
  dialogRef: MdDialogRef<SongDetailComponent>;
  album: any;
  checkDevice: boolean = false;
  songName: any = null;
  songArtistName: any = null;
  playingId: number = 0;
  @Input() artistTracks: boolean = false;
  private helper = new Helper();

  constructor(private authService: AuthService, public dialog: MdDialog, private albumService: AlbumsService, private playerService: PlayerService,) { }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    this.playerService.playerEvent.subscribe((event) => {
      if (event.type === 'track:id') {
        this.playingId=this.playerService.playingId;
        if(this.song.id==this.playingId){
          this.song.isHovering=false;
        }
      }
    });
  }

  ngOnInit() {
    this.playingId=this.playerService.playingId;
    this.checkDevice = false;
    if(screen.width <= 1034) {
      this.checkDevice = true;
    }
    if(this.song.name && this.song.name != null) {
      this.song.name =  this.song.name.toLowerCase();
      this.song.name = this.song.name.charAt(0).toUpperCase() + this.song.name.slice(1);
    }
    if(this.song.name && this.song.name != null && this.song.name.length > 28) {
      this.songName = this.song.name;
    }
    if(this.song.artist) {
      if (this.song.artist.name && this.song.artist.name != null && this.song.artist.name.length > 28) {
        this.songArtistName = this.song.artist.name.slice(0, 28);
      }
    }
  }

  openSongDetail(event) {
    event.stopPropagation();
    event.preventDefault();
    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    width = '37%';
    this.dialogRef = this.dialog.open(SongDetailComponent, {
      width: width
    });
    this.dialogRef.componentInstance.slug = this.song.slug;
    return false;
  }

  handleSongDeleted() {
    this.song = '';
    this.refreshListing.emit({ refresh: true });
  }

}



// WEBPACK FOOTER //
// ./src/app/songs/gridview-songs/gridview-songs.component.ts